<template>
<h1 :class="className" v-html="text.replace(/\n/g, '<br/>')"></h1>
</template>

<script>
export default {
  props: {
    text: String,
    className: String
  }
}
</script>

<style lang="scss" scoped>
.c-text {
  font-size: 1.6rem;
  &-ss {
    font-size: 1.2rem;
  }
  &-s {
    font-size: 1.4rem;
  }
  &-xxl {
    font-weight: 700;
    font-size: 40/1280*100vw;
    line-height: 1.4;
    @include media-queries-sp {
      font-size: 24/375*100vw;
    }
  }
}
</style>
